module.exports = __webpack_public_path__ + "static/media/pic-09.bf07fb4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-09.svg
// module id = 278
// module chunks = 0